import ErrorResponse from './ErrorResponse'

/**
 * Message error.
 */
export default class ErrorMessage extends ErrorResponse { }
